/**
 * HTTP error helpers for ownership / not-found detection.
 *
 * Nest/AI ownership denials (403) and missing resources (404) are treated as
 * "conversation not found" on the FE so a deep link to another user's chat
 * shows the same not-found UI as a missing id.
 */

/** Read the HTTP status from an axios-style error or a fetch-style error. */
export const getHttpStatus = (error: unknown): number | undefined => {
  const e = error as { status?: number; response?: { status?: number } } | null;
  return e?.status ?? e?.response?.status;
};

/** True when the error is an ownership denial (403) or missing resource (404). */
export const isConversationAccessDenied = (error: unknown): boolean => {
  const status = getHttpStatus(error);
  return status === 403 || status === 404;
};
